export default __webpack_public_path__ + "59d1f9fdba8996c7b96966e44ec51e9a.svg";